/*
 *
 * PagoPaDownloadAllPopup
 *
 * @version 1.0.0
 * @author Emanuele Motta
 * @since 10-Dec-2025
*/

import PagoPaDownloadAllPopup from './PagoPaDownloadAllPopupContainer'

export default PagoPaDownloadAllPopup
